// FreeSWITCH may use seconds, milliseconds, or microseconds; Date.now() is milliseconds.
export function epochToSeconds(epoch: number | string): number {
  const epochNum = typeof epoch === 'string' ? parseInt(epoch) : epoch;

  // > 1e15: microseconds; > 1e12: milliseconds (Date.now()); else seconds.
  if (epochNum > 1e15) {
    return Math.floor(epochNum / 1000000);
  }
  if (epochNum > 1e12) {
    return Math.floor(epochNum / 1000);
  }

  return epochNum;
}

export function calculateDuration(
  startEpoch: number | string,
  endEpoch: number | string
): number {
  const startSeconds = epochToSeconds(startEpoch);
  const endSeconds = epochToSeconds(endEpoch);

  return Math.max(0, endSeconds - startSeconds);
}
